module.exports = __webpack_public_path__ + "images/emoji/umbrella.33aa74ccec4abc13371c.png";